import { FC, Fragment, InputHTMLAttributes } from "react";

export type InputTextWhiteprops = InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  textDescribe?: string;
  className?: string;
};

export const InputTextWhite: FC<InputTextWhiteprops> = ({
  label,
  textDescribe,
  ...props
}) => {
  return (
    <Fragment>
      <div className="">
        <label
          htmlFor="price"
          className="block text-sm font-medium leading-6 text-gray-900"
        >
          {label}
        </label>
        <div className="relative rounded-md">
          <input
            {...props}
            className={`block w-full rounded-md  px-2 text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:border-primary sm:text-sm sm:leading-6 ${props.className}`}
          />
        </div>
        <p className={`mt-1 text-sm text-gray-400`}>{textDescribe}</p>
      </div>
    </Fragment>
  );
};
